import type { IUseCase } from 'shared-kernel';
import type { IUserAdminRepository } from '../../domain/ports';

export interface BasculerActivationInput {
  idUtilisateur: string;
  activer: boolean;
}

export class BasculerActivationUseCase implements IUseCase<BasculerActivationInput, void> {
  constructor(private readonly repository: IUserAdminRepository) {}

  async execute(input: BasculerActivationInput): Promise<void> {
    const response = await this.repository.basculerActivation(input.idUtilisateur, input.activer);

    if (!response.succes) {
      throw new Error(response.message || 'Erreur lors du changement d\'activation');
    }
  }
}
